import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardService, DashboardStats } from '../../services/dashboard.service';
import { Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    TableModule
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {
  stats: DashboardStats | null = null;
  loading = true;
  error: string | null = null;

  // Variables simulant les métriques du CAC
  kpis: any = null;
  currentUserStats: any = null;
  isAdmin = false;
  loadingAdminStats = false;
  adminUsersStats: any[] = [];

  constructor(
    private dashboardService: DashboardService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.refresh();
  }

  /**
   * Retourne la date et heure courante formatée
   */
  getCurrentDate(): string {
    return new Date().toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  /**
   * Actualiser les données
   */
  refresh(): void {
    this.loadDashboardData();
  }

  /**
   * Naviguer vers une nouvelle comparaison
   */
  goToCompare(): void {
    this.router.navigate(['/casv2/compare']);
  }

  /**
   * Naviguer vers l'historique
   */
  goToHistory(): void {
    this.router.navigate(['/casv2/historique']);
  }

  /**
   * Formater le montant en euro
   */
  formatAmount(amount: number): string {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(amount);
  }

  /**
   * Obtenir le taux de traitement
   */
  getTreatmentRate(): number {
    if (!this.currentUserStats || this.currentUserStats.projects_this_month === 0) return 0;
    return (this.currentUserStats.projects_treated / this.currentUserStats.projects_this_month) * 100;
  }

  /**
   * Charger les données du dashboard et simuler les KPIs du CAC
   */
  private loadDashboardData(): void {
    this.loading = true;
    this.error = null;

    this.dashboardService.getDashboardStats().subscribe({
      next: (stats) => {
        this.stats = stats;
        
        // Mappage des statistiques CAS vers le modèle de vue CAC
        this.kpis = {
          projects_count: stats.comparisonsThisMonth || 0,
          conversion_rate: 0, // CAS ne gère pas nativement ce taux (à 0 en attendant)
          average_basket: stats.averagePrice || 0,
          monthly_target_completion: Math.min(((stats.comparisonsThisMonth || 0) / 20) * 100, 100)
        };

        const treated = Math.max((stats.comparisonsThisMonth || 0) - (stats.comparisonsThisWeek || 0), 0);

        this.currentUserStats = {
          amount_this_month: 0, // À 0 en attendant
          amount_last_month: 0,
          evolution_amount: 0,
          projects_this_month: stats.comparisonsThisMonth || 0,
          projects_last_month: 0,
          evolution_projects: 0,
          projects_treated: treated,
          projects_to_process: stats.comparisonsThisWeek || 0,
          rank: '-',
          total_users: stats.totalUsers || '-'
        };
        
        this.loading = false;
      },
      error: (err) => {
        console.error('Erreur lors du chargement des statistiques:', err);
        this.error = 'Impossible de charger les données du tableau de bord.';
        this.loading = false;
      }
    });
  }
}
